export const SCHEDULE_SLOT_COUNT = 48
export const SCHEDULE_SLOT_DURATION_MINUTES = 30

export const SCHEDULE_WEEKDAYS = [
    {value: 'WEEKDAY_MONDAY', shortLabel: 'Пн', label: 'Понедельник'},
    {value: 'WEEKDAY_TUESDAY', shortLabel: 'Вт', label: 'Вторник'},
    {value: 'WEEKDAY_WEDNESDAY', shortLabel: 'Ср', label: 'Среда'},
    {value: 'WEEKDAY_THURSDAY', shortLabel: 'Чт', label: 'Четверг'},
    {value: 'WEEKDAY_FRIDAY', shortLabel: 'Пт', label: 'Пятница'},
    {value: 'WEEKDAY_SATURDAY', shortLabel: 'Сб', label: 'Суббота'},
    {value: 'WEEKDAY_SUNDAY', shortLabel: 'Вс', label: 'Воскресенье'},
] as const
